import { ProcessingOrderDetails } from "../models/ProcessingOrder";
import { ProcessingOrderTemplateData } from "./ProcessingOrderTemplateData";
import { ProcessingOrderImportTemplate } from "./ProcessingOrderImportTemplate";
import { cloneDeep } from "lodash";

export const getProcessingOrderTemplate = (
  processingOrder: ProcessingOrderDetails
) => {
  return ProcessingOrderImportTemplate(prepareData(processingOrder));
};

const prepareData = (processingOrder: ProcessingOrderDetails) => {
  const templateData: ProcessingOrderTemplateData = {
    processingOrder: cloneDeep(processingOrder),
  };

  return templateData;
};
